<div class="processing-text">
    <i class="fa fa-spinner fa-spin"></i>
</div>
